export default __webpack_public_path__ + "static/media/dark2.b91d10bd.jpg";